import type { UserDetailType } from './auth'

export type BodyMassIndexType = {
  body_mass_index: number,
  body_mass_index_type: string,
  warning: string | null,
}

export type DailyNutritionTarget = {
  calories: number,
  proteins: number,
  fats: number,
  carbohydrates: number,
}

export type DailyNutritionIntake = {
  calories: number,
  proteins: number,
  fats: number,
  carbohydrates: number,
}

export type DailyStatsType = {
  daily_water_target: number,
  daily_water_intake: number,
  daily_nutrition_target: DailyNutritionTarget,
  daily_nutrition_intake: DailyNutritionIntake,
  daily_calorie_burned: number,
}

export type DailyCalorieByDayType = {
  date: Date | string,
  daily_calorie: number,
}

export type ProfileType = {
  readonly id: number,
  user_id: ProfileType['user']['id'],
  user: UserDetailType,
  is_subscribed: boolean,
  self_name: string,
  age: number,
  birth_date: Date | string | null,
  height: number | null,
  weight: number,
  phone: string | null,
  activity_level: number,
  start_date: Date | string,
  need_onboarding: boolean,
  body_mass_index: BodyMassIndexType,
  calorie_deficit: number,
  calorie_deficit_next_level: number,
  daily_calorie: number,
  daily_calorie_next_level: number,
  daily_calorie_by_days: DailyCalorieByDayType[],
  social_photo_url: string | null,
  self_loaded_photo_url: string | null,
  main_training_page_completed: boolean,
}

export type ProfileBodyType = {
  self_name?: string,
  birth_date?: string,
  height?: number,
  activity_level?: number,
  weight?: number,
  main_training_page_completed?: boolean,
}

export type ProfileAvatarResponse = {
  self_loaded_photo_url: string
}

export function castProfile (profile: ProfileType): ProfileType {
  const result: ProfileType = { ...profile }
  result.birth_date = profile.birth_date ? new Date(profile.birth_date) : null
  result.start_date = new Date(profile.start_date)
  return result
}
